import { FC } from "react"

interface ToggleProps {
  checked: boolean
  onChange: () => void
  disabled?: boolean
}

export const Toggle: FC<ToggleProps> = ({ checked, onChange, disabled = false }) => {
  return (
    <label className="relative inline-flex items-center w-11 h-6 cursor-pointer">
      <input type="checkbox" className="sr-only peer" checked={checked} onChange={onChange} disabled={disabled} />
      <div className="w-full h-full bg-[rgba(169,78,206,0.4)] peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-purple-400 rounded-full peer peer-checked:bg-[rgba(169,78,206,1)] transition-colors duration-300 ease-in-out peer-disabled:opacity-50 peer-disabled:cursor-not-allowed" />
      <div className="absolute top-0.5 left-0.5 w-5 h-5 bg-[#9f90a7] rounded-full shadow-md transition-bg transform transition-transform duration-300 ease-in-out peer-checked:translate-x-5 peer-checked:bg-[#cccccc]" />
    </label>
  )
}
